/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable camelcase */
import React, { useRef, useLayoutEffect } from 'react'

import { HorizontalDim, VerticalDim } from './elements/GridDim'

import { Item, PlaceHolder } from './elements/Items'
// Items
import {
  gridGF,
  gridMF,
  gridPF,
  gridGS,
  gridMS,
  board40x15,
  board60x15,
  board80x15,
  board40x20,
  board60x20,
  board80x20,
  board60x30_t2,
  board60x30_t2_left,
  board60x30_t2_right,
  board60x30_t3,
  board80x30_t2,
  board80x30_t2_left,
  board80x30_t2_right,
  board80x30_t3,
  desk60x50,
  desk80x50,
  potHolder_11,
  potHolder_11_with_pot,
  potHolder_15,
  potHolder_15_with_pot,
  hooks,
  ps40,
  ps60,
  vaseHolder_10,
  vaseHolder_15,
  frameHolder_40,
  computerHolder,
  hangerHolder,
  glassesHolder_with_glasses,
  box,
  wardrobe40_with_hanger,
  wardrobe60_with_hanger,
  wardrobe80_with_hanger,
} from '../referential/gassienComponents'

const Box = ({ ...args }) => (
  <PlaceHolder {...args} {...box} />
)

const GridGF = ({ ...args }) => (
  <Item {...args} {...gridGF} />
)

const GridMF = ({ ...args }) => (
  <Item {...args} {...gridMF} />
)

const GridPF = ({ ...args }) => (
  <Item {...args} {...gridPF} />
)

const GridGS = ({ ...args }) => (
  <Item {...args} {...gridGS} />
)

const GridMS = ({ ...args }) => (
  <Item {...args} {...gridMS} />
)

const Board40x15 = ({ ...args }) => (
  <Item {...args} {...board40x15} />
)

const Board60x15 = ({ ...args }) => (
  <Item {...args} {...board60x15} />
)

const Board80x15 = ({ ...args }) => (
  <Item {...args} {...board80x15} />
)

const Board40x20 = ({ ...args }) => (
  <Item {...args} {...board40x20} />
)

const Board60x20 = ({ ...args }) => (
  <Item {...args} {...board60x20} />
)

const Board80x20 = ({ ...args }) => (
  <Item {...args} {...board80x20} />
)

const Board60x30_t2 = ({ ...args }) => (
  <Item {...args} {...board60x30_t2} />
)

const Board60x30_t2_left = ({ ...args }) => (
  <Item {...args} {...board60x30_t2_left} />
)

const Board60x30_t2_right = ({ ...args }) => (
  <Item {...args} {...board60x30_t2_right} />
)

const Board60x30_t3 = ({ ...args }) => (
  <Item {...args} {...board60x30_t3} />
)

const Board80x30_t2 = ({ ...args }) => (
  <Item {...args} {...board80x30_t2} />
)

const Board80x30_t2_left = ({ ...args }) => (
  <Item {...args} {...board80x30_t2_left} />
)

const Board80x30_t2_right = ({ ...args }) => (
  <Item {...args} {...board80x30_t2_right} />
)

const Board80x30_t3 = ({ ...args }) => (
  <Item {...args} {...board80x30_t3} />
)

const Desk80x50 = ({ ...args }) => (
  <Item {...args} {...desk80x50} />
)

const Desk60x50 = ({ ...args }) => (
  <Item {...args} {...desk60x50} />
)

const PotHolder11 = ({ ...args }) => (
  <Item {...args} {...potHolder_11} />
)

const PotHolder11WithPot = ({ ...args }) => (
  <Item {...args} {...potHolder_11_with_pot} />
)

const PotHolder15 = ({ ...args }) => (
  <Item {...args} {...potHolder_15} />
)

const PotHolder15WithPot = ({ ...args }) => (
  <Item {...args} {...potHolder_15_with_pot} />
)

const Hooks = ({ ...args }) => (
  <Item {...args} {...hooks} />
)

const Ps40 = ({ ...args }) => (
  <Item {...args} {...ps40} />
)

const Ps60 = ({ ...args }) => (
  <Item {...args} {...ps60} />
)

const VaseHolder10 = ({ ...args }) => (
  <Item {...args} {...vaseHolder_10} />
)
const VaseHolder15 = ({ ...args }) => (
  <Item {...args} {...vaseHolder_15} />
)
const FrameHolder40 = ({ ...args }) => (
  <Item {...args} {...frameHolder_40} />
)
const ComputerHolder = ({ ...args }) => (
  <Item {...args} {...computerHolder} />
)
const HangerHolder = ({ ...args }) => (
  <Item {...args} {...hangerHolder} />
)
const GlassesHolderWithGlasses = ({ ...args }) => (
  <Item {...args} {...glassesHolder_with_glasses} />
)

const Wardrobe40WithHanger = ({ ...args }) => (
  <Item {...args} {...wardrobe40_with_hanger} />
)
const Wardrobe60WithHanger = ({ ...args }) => (
  <Item {...args} {...wardrobe60_with_hanger} />
)
const Wardrobe80WithHanger = ({ ...args }) => (
  <Item {...args} {...wardrobe80_with_hanger} />
)

const WhiteBoard = ({
  elements,
  selectElement,
  selectedElement,
  removeElement,
  setOriginalPosition,
  offsetX,
  offsetY,
  offsetWidth,
  offsetHeight,
  setItemPosition,
  isTagged,
  isQuotes,
  res,
  vRes,
  baseRes,
  wholeDimensions,
}) => {
  const commonElementsProps = {
    selectElement,
    removeElement,
    setItemPosition,
    isTagged,
    isQuotes,
    res,
    baseRes,
    offsetX,
    offsetY,
    offsetWidth,
    offsetHeight,
  }

  const mainStyle = {
    width: '100%',
    height: `${vRes * 400}px`,
  }

  const inputEl = useRef(null)

  useLayoutEffect(() => {
    const initialOffsetX = inputEl.current.offsetLeft
    const initialOffsetY = inputEl.current.offsetTop
    setOriginalPosition({
      x: initialOffsetX,
      y: initialOffsetY,
      divWidth: inputEl.current.offsetWidth,
      divHeight: inputEl.current.offsetHeight,
    })
  })

  const elementsToShow = elements.map((el) => {
    switch (el.type) {
      case 'gridGF':
        return (
          <GridGF
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'gridMF':
        return (
          <GridMF
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'gridPF':
        return (
          <GridPF
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'gridGS':
        return (
          <GridGS
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'gridMS':
        return (
          <GridMS
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board40x15':
        return (
          <Board40x15
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board60x15':
        return (
          <Board60x15
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board80x15':
        return (
          <Board80x15
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board40x20':
        return (
          <Board40x20
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board60x20':
        return (
          <Board60x20
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board80x20':
        return (
          <Board80x20
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board60x30_t2':
        return (
          <Board60x30_t2
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board60x30_t2_left':
        return (
          <Board60x30_t2_left
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board60x30_t2_right':
        return (
          <Board60x30_t2_right
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board60x30_t3':
        return (
          <Board60x30_t3
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board80x30_t2':
        return (
          <Board80x30_t2
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board80x30_t2_left':
        return (
          <Board80x30_t2_left
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board80x30_t2_right':
        return (
          <Board80x30_t2_right
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'board80x30_t3':
        return (
          <Board80x30_t3
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'desk80x50':
        return (
          <Desk80x50
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'desk60x50':
        return (
          <Desk60x50
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'potHolder_11':
        return (
          <PotHolder11
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'potHolder_11_with_pot':
        return (
          <PotHolder11WithPot
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'potHolder_15':
        return (
          <PotHolder15
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'potHolder_15_with_pot':
        return (
          <PotHolder15WithPot
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'hooks':
        return (
          <Hooks
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'ps40':
        return (
          <Ps40
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'ps60':
        return (
          <Ps60
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'vaseHolder_10':
        return (
          <VaseHolder10
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'vaseHolder_15':
        return (
          <VaseHolder15
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'frameHolder_40':
        return (
          <FrameHolder40
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'computerHolder':
        return (
          <ComputerHolder
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'hangerHolder':
        return (
          <HangerHolder
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )


      case 'glassesHolder_with_glasses':
        return (
          <GlassesHolderWithGlasses
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'wardrobe40_with_hanger':
        return (
          <Wardrobe40WithHanger
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )
      case 'wardrobe60_with_hanger':
        return (
          <Wardrobe60WithHanger
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )
      case 'wardrobe80_with_hanger':
        return (
          <Wardrobe80WithHanger
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            isSelected={el.id === selectedElement}
            {...commonElementsProps}
          />
        )

      case 'box':
        return (
          <Box
            id={el.id}
            key={el.id}
            x={el.x}
            y={el.y}
            collision={el.collision}
            width={el.width}
            height={el.height}
            realWidth={el.realWidth}
            realHeight={el.realHeight}
            boxName={el.boxName || null}
            boxType={el.boxType || null}
            isSelected={el.id === selectedElement}
            view={!('view' in el) || el.view}
            viewQuotes={!('viewQuotes' in el) || el.viewQuotes}
            {...commonElementsProps}
          />
        )

      default:
        return null
    }
  })

  return (
    <div id="workspace" style={{ width: 'auto' }}>

      <HorizontalDim
        min={wholeDimensions.minX}
        max={wholeDimensions.maxX}
        wholeWidth={wholeDimensions.wholeWidth}

      />
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <VerticalDim
          divHeight={mainStyle.height}
          min={wholeDimensions.minY}
          max={wholeDimensions.maxY}
          wholeHeight={wholeDimensions.wholeHeight}
        />

        <div
          className="whiteboard"
          id="whiteboard"
          ref={inputEl}
          style={mainStyle}
          onClick={() => selectElement(null)}
        >
          {elementsToShow}
        </div>
      </div>
    </div>
  )
}

export default WhiteBoard
